import api from "./api";
import rhApi from "./rhApi";
import { getSucursalInfo } from "./auth";

// Ported from sge_infantil_web/src/pages/workers/{create,list}/index.js
// (endpoints go through the main `api` instance, not rhApi.js — the original
// screens never actually used rhApi.js despite it existing in services/).
export async function listWorkers() {
  const sucursalId = getSucursalInfo()?.id || 1;
  return api.get(`api/worker/${sucursalId}`);
}

export async function createWorker(payload) {
  return api.post("api/worker", payload);
}

export async function updateWorker(id, payload) {
  return api.put(`api/worker/${id}`, payload);
}

export async function toggleWorkerActive(id, active, updatedBy) {
  return api.put(`api/worker/inactivate/${id}`, { active, updatedBy });
}

// Ported from sge_infantil_web's "Marcar Presença" (worker self-service
// attendance) login-page link. Unlike every other worker endpoint above,
// this goes through the separate HR backend (rhApi) — it's how an
// unauthenticated worker identifies themselves by contact before marking
// their own entry/exit, without needing a system login.
export async function getWorkerByContact(contact) {
  return rhApi.get(`worker/by-contact/${contact}`);
}
